import ActivePuzzle from './ActivePuzzle';

export default ActivePuzzle;
